<template>
	<div>
		<div class="flex justify-between lg:justify-end items-center">
			<div class="font-bold lg:font-normal lg:hidden">Einzelpreis:</div>
			<div class="lg:text-right">{{ item?.price?.gross.toFixed(2) }} €</div>
		</div>
	</div>
</template>

<script setup lang="ts">
defineProps<{ 
	item: OrderItem;
}>()
</script>
